import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import { alphaSortNutrient, createMultiFoodFullRows } from '../../util/util';
import MultiFoodResultTable from './MultiFoodResultTable';

const createCsvHeader = foods => {
  const csvHeader = [
    {label: 'Nutrient', key: 'nutrient'},
    {label: 'Unit', key: 'unit'},
  ];
  foods.forEach((food, i) => {
    csvHeader.push({
      label: food.shortname, key: `food${i + 1}`
    });
  });
  return csvHeader;
};

class MultiFoodFullAlphabetical extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    const csvHeader = createCsvHeader(this.props.selectedFoods);
    this.props.setCsvHeader(csvHeader);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.selectedFoods !== nextProps.selectedFoods) {
      const csvHeader = createCsvHeader(nextProps.selectedFoods);
      this.props.setCsvHeader(csvHeader);
    }
  }

  render() {
    const {
      unitFetch, fullComponentSetFetch,
      food1FullFetch, food2FullFetch, food3FullFetch
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch, fullComponentSetFetch,
          food1FullFetch, food2FullFetch, food3FullFetch
        ].filter(n => n))}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([units, fullComponentSet, ...foodFulls]) {
    const fullComponents = fullComponentSet.components.sort(alphaSortNutrient);

    // combine full of each food to food objects
    const selectedFoods = this.props.selectedFoods;
    selectedFoods.forEach((food, i) => {
      food.components = foodFulls[i];
    });

    const { selectedReport, per100g } = this.props;

    const tableData = createMultiFoodFullRows(fullComponents, selectedFoods, units, per100g);

    return (
      <div className="MultiFoodResult">

        <MultiFoodResultTable
          tableData={tableData}
          selectedFoods={selectedFoods}
          selectedReport={selectedReport}
          setCsvData={this.props.setCsvData}
           per100g = {per100g}
        />

      </div>
    );
  }
}

MultiFoodFullAlphabetical.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  fullComponentSetFetch: PropTypes.instanceOf(PromiseState),
  food1FullFetch: PropTypes.instanceOf(PromiseState),
  food2FullFetch: PropTypes.instanceOf(PromiseState),
  food3FullFetch: PropTypes.instanceOf(PromiseState),
  selectedFoods: PropTypes.array,
  selectedReport: PropTypes.string,
  per100g: PropTypes.bool.isRequired,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

const fetch = props => {
  if (!props.selectedFoods) { return null; } // don't fetch
  let fetchObject = {
    unitFetch: `${BASE_URL}/unit`,
    fullComponentSetFetch: `${BASE_URL}/component/set/12`,
  };
  props.selectedFoods.forEach((food, i) => {
    const query = food.serving_size_value ? `?amount=${food.serving_size_value}&` : '?';
    fetchObject[`food${i + 1}FullFetch`] = `${BASE_URL}/fiav/food/${food.recordid}${query}comp_group_id=12`;
  });
  return fetchObject;
};

export default connect(fetch)(MultiFoodFullAlphabetical);



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodFullAlphabetical.js